module.exports = __webpack_public_path__ + "static/img/作品73.d84b593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品73.png
// module id = Jfc2
// module chunks = 1